import { AiOutlineUser } from 'react-icons/ai';
import { twMerge } from 'tailwind-merge';
import { ReadEmployee } from '../services/gql/graphql.generated';

export const merge = (...classes: (string | undefined | null)[]) => {
  return twMerge(classes);
};

// Drops a call for `key` if one is already in flight, so a fast repeat click can't fire
// `action` again before the first call has settled. The check runs before any `await`,
// so it isn't racing a re-render the way a `disabled` prop would be.
export const guardOnce = async <Key,>(inFlight: Set<Key>, key: Key, action: () => Promise<void>) => {
  if (inFlight.has(key)) return;
  inFlight.add(key);
  try {
    await action();
  } finally {
    inFlight.delete(key);
  }
};

export const isEmployeeDeactivatedOrDeleted = (employee: ReadEmployee) => {
  return employee.isDeactivated || employee.isDeleted;
};

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateEmail = (email: string) => {
  if (!email) return true; //If the email is undefined then it is valid - kind of a quirk with the add user forms
  return emailRegex.test(email);
};

export const breadcrumbName = (
  employee: ReadEmployee,
  employeeString: (firstName: string, lastName: string) => string
) => {
  return (
    <>
      <AiOutlineUser className="mr-2" />
      {employeeString(employee?.firstName ?? '', employee?.lastName ?? '')}
    </>
  );
};
